import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
export function NewsletterSection() {
  const [agreed, setAgreed] = useState(false);
  return <section className="relative py-28 md:py-36 bg-robeta-black overflow-hidden" data-id="element-245">
      {/* Subtle atmospheric glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-robeta-copper/8 via-transparent to-transparent pointer-events-none" data-id="element-246" />

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-247">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="max-w-xl mx-auto text-center" data-id="element-248">
          <div className="w-16 h-px bg-robeta-copper mx-auto mb-10" data-id="element-249" />

          <h2 className="text-3xl md:text-4xl font-bold text-white uppercase tracking-editorial mb-4" data-id="element-250">
            Join the Robeta Journey
          </h2>

          <p className="text-white/60 font-light mb-12" data-id="element-251">
            Be the first to know about new models, dealer locations, and
            exclusive events.
          </p>

          <form className="flex flex-col gap-6 max-w-md mx-auto" data-id="element-252">
            <div className="flex flex-col sm:flex-row items-stretch gap-4" data-id="element-253">
              <input type="email" placeholder="Enter your email address" className="flex-grow bg-transparent border-b border-white/20 focus:border-robeta-copper py-3 px-2 text-white placeholder-white/30 focus:outline-none transition-colors rounded-none font-light" data-id="element-254" />
              <button type="button" disabled={!agreed} className={`px-8 py-3 font-bold uppercase tracking-widest transition-all duration-300 text-sm ${agreed ? 'bg-robeta-copper text-robeta-black hover:bg-white' : 'bg-white/10 text-white/30 cursor-not-allowed'}`} data-id="element-255">
                Subscribe
              </button>
            </div>

            {/* Terms Checkbox */}
            <div className="flex items-start gap-3 justify-center cursor-pointer group" onClick={() => setAgreed(!agreed)} data-id="element-256">
              <div className={`mt-0.5 w-5 h-5 border flex-shrink-0 flex items-center justify-center transition-colors duration-300 ${agreed ? 'bg-robeta-copper border-robeta-copper' : 'border-white/30 group-hover:border-robeta-copper/60'}`} data-id="element-257">
                {agreed && <Check className="w-3.5 h-3.5 text-white" data-id="element-258" />}
              </div>
              <p className="text-xs text-white/50 leading-relaxed text-left select-none" data-id="element-259">
                I agree to the{' '}
                <a href="#" onClick={e => e.stopPropagation()} className="text-robeta-copper hover:text-white underline underline-offset-2 transition-colors" data-id="element-260">
                  Terms of Service
                </a>{' '}
                and{' '}
                <a href="#" onClick={e => e.stopPropagation()} className="text-robeta-copper hover:text-white underline underline-offset-2 transition-colors" data-id="element-261">
                  Privacy Policy
                </a>
                .
              </p>
            </div>
          </form>
        </motion.div>
      </div>
    </section>;
}